import React, { useContext, useEffect, useState } from "react";

interface WindowDimensionsProviderState {
    height: number;
    width: number;
}

const WindowDimensionsContext = React.createContext<any>({
    height: window.innerHeight,
    width: window.innerWidth,
});

interface WindowDimensionsProviderProps {
    children: any;
}

const WindowDimensionsProvider = ({
    children,
}: WindowDimensionsProviderProps) => {
    const [windowDimensionsProviderState, setWindowDimensionsProviderState] =
        useState<WindowDimensionsProviderState>({
            height: window.innerHeight,
            width: window.innerWidth,
        });

    useEffect(() => {
        function handleResize() {
            setWindowDimensionsProviderState({
                height: window.innerHeight,
                width: window.innerWidth,
            });
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <WindowDimensionsContext.Provider value={windowDimensionsProviderState}>
            {children}
        </WindowDimensionsContext.Provider>
    );
};

export const useWindowDimensions = () => {
    return useContext(WindowDimensionsContext);
};

export default WindowDimensionsProvider;
